import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as css from './RefundInfo.css';
var RefundInfo = function () {
    var t = useTranslation('Refund').t;
    return (React.createElement("div", { className: css.info }, t('If you change your mind, or want to create a new request with different parameters, delete this request.')));
};
export default RefundInfo;
